<template>
  <section class="login">
    <BContainer>
      <Login />
    </BContainer>
  </section>
</template>
<script setup>
import Login from "@/esf_venlo_base/core/components/Login.vue";
</script>